module.exports = __webpack_public_path__ + "static/media/audioVoice.da1c4c8.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audioVoice.mp3
// module id = s/Kb
// module chunks = 1